export const PROGRESS_CLEARED = 'PROGRESS_CLEARED';

export const progressCleared = () => dispatch =>
  dispatch({
    type: PROGRESS_CLEARED,
  });
